<template>
  <div class="chat-container" style="border-radius: 10% !important;">

    <!-- Sidebar 462279 -->
    <div :class="['sidebar', { 'sidebar-hidden': !isDesktop && activeChat }]">

      <!-- Card Profile -->
      <div class="profile-card">
        <a-avatar shape="square" :size="35" :src="userProfile.avatar" class="profile-avatar" />
        <div class="profile-info">
          <h3 class="profile-avatar-name">{{ userProfile.name }}</h3>
          <p :class="['status', userProfile.online ? 'online' : 'offline']">

            <a-tag color="purple">
              &nbsp;&nbsp;{{ $store.state.role.RulesUser.roles.includes('staff') ||
                $store.state.role.RulesUser.roles.includes('faculty') ? 'Staff / Lecture' : 'Student' }}&nbsp;&nbsp;
            </a-tag>
          </p>
        </div>
      </div>
      <!-- รายการแชท -->
      <div class="sidebar-header">
        <div>
          <h5 class="mt-10 mb-10 ml-10 font-web"><a-icon class="mr-10" type="unordered-list" /> History </h5>
        </div>
        <div class="text-right">
          <a-tooltip placement="top">
            <template slot="title">
              <span>New Chat</span>
            </template>
            <a-button @click="handleOpenModalId" type="link" size="large">
              <strong><a-icon type="form"
                  style="font-size: 28px; color: #462279 !important; font-weight: 900;" /></strong>
            </a-button>
          </a-tooltip>
        </div>
      </div>
      <!-- รายการแชท -->
      <ul class="chat-list">
        <li v-for="(chat, index) in chats" :key="index" @click="selectChat(chat)"
          :class="{ 'active-chat': activeChat === chat }">
          <div class="chat-info">
            <p class="chat-name">{{ chat.name }}</p>
            <p v-if="chat.name !== 'Loading ...'" style="font-size: 12px !important" class="chat-message"><a-icon
                type="calendar" class="mr-5" /> {{ moment(chat.created_at).format('DD / MMM / YYYY') }} <a-icon
                class="ml-5 mr-5" type="clock-circle" /> {{ moment(chat.created_at).format('HH:mm:ss') }}</p>
            <p v-else style="font-size: 12px !important" class="chat-message"><a-icon type="loading" class="mr-10" />
              Copter
              Ver. Beta0.1 </p>
          </div>
        </li>
      </ul>
    </div>

    <!-- Main Chat (activeChat) -->
    <div class="chat-box" v-if="activeChat">
      <div class="chat-header">
        <a-button class="mr-10" v-if="!isDesktop" @click="backToChats" type="link" :size="size">
          <a-icon :style="{ fontSize: '28px', color: '#ffffff !important' }" type="menu-fold" />
        </a-button>
        <a-avatar shape="square" :size="30" icon="user" src="/images/Khuncopter.png" class="avatar" />
        <div>
          <h6 style="color: #ffffff" class="font-web mt-0 mb-0">Copter</h6>
          <p style="font-size: 10px;" class="ml-10 font-web mt-0 mb-0">Ver. Beta0.1</p>
        </div>
      </div>

      <div ref="chatMessages" :class="['chat-messages', { 'shrink-messages': isInputFocused }]">
        <div v-for="(message, index) in activeChat.messages" :key="index"
          :class="['message', message.from === 'me' ? 'sent' : 'received']">
          <p class="message-text">
            <a-icon v-if="message.id === 'loading send'" type="sync" spin /> <span class="markdown-content"
              v-html="renderMarkdown(message.text)"></span>
          </p>
          <span class="message-time">{{ message.time }}</span>
        </div>
      </div>

      <div class="chat-input">
        <input :disabled="!viewHistoryChat" v-model="newMessage" @keyup.enter="sendMessage"
          placeholder="Type a message..." @focus="isInputFocused = true" @blur="isInputFocused = false" />
        <button :disabled="!viewHistoryChat" class="ml-10" @click="sendMessage">Send</button>
      </div>
    </div>

    <!-- modal -->
    <a-modal title="Suppose you are a student" :visible="modalUserId" @cancel="handleCloseModalId">
      <div class="mt-10 mb-10">
        <a-form-item help="Please enter your designated student ID for simulation purposes before using the AI system.">
          <a-input-search :max-length="7" v-model="userName" class="mb-2" placeholder="search student id simulation"
            enter-button="Check" size="large" @search="onSearch" />
        </a-form-item>
        <p v-if="![''].includes(errorStatus)" class="font-web mt-0 mb-0 text-danger">Error message : {{ errorStatus }}
        </p>
      </div>
      <template slot="footer">
        <div class="">
          <a-button type="primary" icon="wechat" style="width: 150px !important;" class="ml-10" :disabled="!idStatus"
            @click="createToppic" :loading="loadingCreateMsg">Create New Chat</a-button>
          <a-button style="width: 100px !important;" class="ml-10" @click="handleCloseModalId">Close</a-button>
        </div>
      </template>
    </a-modal>
    <!-- modal eror -->
    <a-modal title="Copter is currently unavailable." :visible="visibleModal">
      <a-result status="500" title="500" sub-title="Sorry, Copter is wrong.">
        <div class="desc">
          <p class="mt-0 mb-0 font-web" style="font-size: 16px;">
            <strong>The content you following error:</strong>
          </p>
          <p class="mt-10 mb-0 font-web">
            <a-icon :style="{ color: 'red' }" type="close-circle" /> Status:
            <br> Identified
            We have identified the issue and are working to roll out a fix.
          </p>
        </div>
      </a-result>
      <template slot="footer">
        <a-button style="width: 100px !important;" class="ml-10">
          Close
        </a-button>
      </template>
    </a-modal>

  </div>
</template>

<script>
const marked = require("marked");

export default {
  data() {
    return {
      // old
      closeInput: true,
      visibleModal: false,
      loadingContent: false,
      dataToppic: [],
      loadingToppic: false,
      dataChat: [],
      dataViewMsg: [],
      loadingChat: false,
      checkedList: ['ข้อมูลทั่วไป', 'ข้อมูลการศึกษา', 'คู่มือการใช้งาน', 'ช่วยแจ้งปัญหา / สร้างแบบคำขอ'],
      plainOptions: ['ข้อมูลทั่วไป', 'ข้อมูลการศึกษา', 'คู่มือการใช้งาน', 'ช่วยแจ้งปัญหา / สร้างแบบคำขอ'],
      defaultCheckedList: ['ข้อมูลทั่วไป', 'ข้อมูลการศึกษา', 'คู่มือการใช้งาน', 'ช่วยแจ้งปัญหา / สร้างแบบคำขอ'],
      indeterminate: true,
      checkAll: false,
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 6,
      },
      textContent: '',
      valueRate: 0,
      valueComment: '',
      visiblePopcon: false,
      loadingCreateMsg: false,
      lockInput: false,
      //
      modalUserId: false,
      userName: '',
      modeChat: true,
      firstChat: '',
      // check id status
      idStatus: false,
      errorStatus: '',
      //
      viewHistoryChat: false,
      // new
      isInputFocused: false, // เช็คว่ามีการคลิกที่ input หรือไม่
      isDesktop: globalThis.innerWidth >= 768,
      newMessage: "",
      activeChat: null,
      userProfile: {
        name: "",
        avatar: "",
        online: false,
      },

      chats: [],
    };
  },
  methods: {
    selectChat(chat) {
      this.viewHistoryChat = false
      this.activeChat = chat;
    },
    renderMarkdown(text) {
      return marked.parse(text); // แปลง Markdown เป็น HTML
    },
    backToChats() {
      this.activeChat = null;
    },
    checkScreenSize() {
      this.isDesktop = globalThis.innerWidth >= 768;
    },
    // profile Staff
    async getBaseProfile() {
      this.userProfile = {
        name: "",
        avatar: "",
        online: true,
      }
      try {
        const resBaseProfile = await this.$http.get(`/staff/profile/me/`);
        if (resBaseProfile.status === 200) {
          this.userProfile = {
            name: `${resBaseProfile.data.title.name_eng} ${resBaseProfile.data.name} ${resBaseProfile.data.surname}`,
            avatar: resBaseProfile.data.img,
            online: true,
          }
        } else {
          const error = new Error('API Error');
          error.resBaseProfile = resBaseProfile;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promblem issue connect api : /staff/profile/me/`,
        });
      }
    },
    // profile Std
    async getStudentProfile() {
      this.userProfile = {
        name: "",
        avatar: "",
        online: true,
      }
      try {
        const resStudent = await this.$http.get(`/student/profile/me/`);
        if (resStudent.status === 200) {
          this.userProfile = {
            name: `${resStudent.data.title} ${resStudent.data.english_first_name} ${resStudent.data.english_last_name}`,
            avatar: "https://icapp.muic.mahidol.ac.th/source/pic/" +
              resStudent.data.id +
              ".jpg",
            online: true,
          }
        } else {
          const error = new Error('API Error');
          error.resStudent = resStudent;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promblem issue connect api : /student/profile/me`,
        });
      }
    },
    //
    scrollToBottom() {
      this.$nextTick(() => {
        const chatMessages = this.$refs.chatMessages;
        if (chatMessages) {
          chatMessages.scrollTop = chatMessages.scrollHeight;
        }
      });
    },
    // chat condition
    formatChatMessages(arrayMsg) {
      if (arrayMsg.length === 0) {
        return [{
          id: '8888',
          from: "them",
          text: `Hi there! I'm Copter, your MUIC Assistant. I'm here to help answer your questions and assist you with any inquiries you might have. </br> Try typing <span class='text-danger'>" who am i "</span> to get started! 😊`,
          time: this.moment().format('LT')
        }]
      }
      return arrayMsg.map(element => ({
        id: '9999999999',
        from: element.type === "ASSISTANT" ? 'them' : 'me',
        text: `${element.content}`,
        time: `${this.moment(element.created_at).format('HH:ss:mm')}`
      }))
    },
    setMassagesData(arrayMsg, texCase) {
      if (texCase === 'listToppic') {
        return this.formatChatMessages(arrayMsg)
      }

      if (arrayMsg.length != 0) {
        return `${arrayMsg[0].content}`
      }
      return `Copter is thinking... 🤔`
    },
    async getHistory() {
      this.closeInput = false
      this.visibleModal = false
      this.loadingContent = true
      this.loadingToppic = true
      this.loadingChat = true
      this.dataToppic = []
      this.dataChat = []
      this.dataViewMsg = []
      this.chats = [{
        id: 999,
        name: "Loading ...",
        avatar: "",
        lastMessage: "",
        messages: [],
        updated_at: this.moment().format(),
        created_at: this.moment().format(),
        is_active: true,
      }]
      try {
        const res = await this.$http.get('/line-bot/ai/app/');
        if ([200, 201].includes(res.status)) {

          if (res.data.results.length === 0) {

            // Say hi first 
            this.chats.push({
              id: 9999,
              name: `Hi there! I'm Copter`,
              avatar: "",
              lastMessage: "",
              messages: [
                {
                  id: '8888',
                  from: "them",
                  text: `Your MUIC Assistant. I'm here to help answer your questions and assist you with any inquiries you might have. </br> Try typing "who am i" to get started! 😊 </br> <span class='text-danger' >Please click icon " <b><svg viewBox="64 64 896 896" data-icon="form" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"></path><path d="M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z"></path></svg></b> " create new toppic</span>`,
                  time: this.moment().format('LT')
                },
              ],
              updated_at: this.moment().format(),
              created_at: this.moment().format(),
              is_active: true,
            })
            const indexLoading = this.chats.findIndex(itemLoad => itemLoad.id === 999)
            this.chats.splice(indexLoading, 1);

          } else {

            console.log('res.data')
            this.chats = res.data.results.map((item, index) => {
              return {
                id: item.id,
                name: this.setMassagesData(item.messages, `Title`),
                avatar: "",
                lastMessage: "",
                messages: this.setMassagesData(item.messages, `listToppic`),
                updated_at: item.updated_at,
                created_at: item.created_at,
                is_active: item.is_active,
              };
            });

          }

          // เปิดประวัติอันล่าสุด
          this.selectChat(this.chats[0]);


        } else {
          const error = new Error('API Error');
          error.res = res;
          throw error;
        }
      } catch (error) {
        this.loadingToppic = false
        this.loadingChat = false
        this.loadingContent = false
        this.visibleModal = true
        this.closeInput = true
      }
    },
    async onSearch(value) {
      this.idStatus = false
      this.errorStatus = ''
      const reg = /^-?\d*(\.\d*)?$/;
      if ((!Number.isNaN(value) && reg.test(value)) || value.length === 7) {
        try {
          const res = await this.$http.get(`/student/profile/search_by_id/?q=${value}`);
          if ([200, 201].includes(res.status)) {
            this.userName = value
            this.idStatus = res.data.found
            this.errorStatus = res.data.found ? `` : `Student id: ${value} not found !!!`
          }
          else {
            const error = new Error('API Error');
            error.res = res;
            throw error;
          }
        } catch (error) {
          this.idStatus = false
          this.errorStatus = `Student id: ${value} not format !!!`
          this.userName = ''
          console.log('error')
        }
      } else {
        this.userName = ''
        this.errorStatus = `Student id: ${value} not format !!!`
      }
    },
    onChangeFormValidate(e) {
      const { value } = e.target;
      const reg = /^-?\d*(\.\d*)?$/;
      if ((!Number.isNaN(value) && reg.test(value)) || value === '' || value === '-') {
        this.userName = Number.parseInt(`${value}`) <= 6781308 ? `${value}` : '';
      } else {
        this.userName = 6280123
      }
    },
    handleOpenModalId() {
      this.idStatus = false
      this.errorStatus = ``
      this.userName = ''
      if (this.$store.state.role.RulesUser.roles.includes('staff') || this.$store.state.role.RulesUser.roles.includes('faculty')) {
        this.modalUserId = true
      } else {
        this.createToppic()
      }
    },
    handleCloseModalId() {
      this.modalUserId = false
    },
    async createToppic() {

      this.firstChat = 'first'
      this.loadingCreateMsg = true

      this.chats.push({
        id: 999,
        name: "Loading ...",
        avatar: "",
        lastMessage: "",
        messages: [],
        updated_at: this.moment().format(),
        created_at: this.moment().format(),
        is_active: true,
      })

      try {
        const res = await this.$http.post('/line-bot/ai/app/')
        if ([201].includes(res.status)) {
          await this.getHistory()
          this.viewHistoryChat = true
          this.loadingCreateMsg = false
          this.handleCloseModalId()
        } else {
          const error = new Error('API Error');
          error.res = res;
          throw error;
        }
      } catch (error) {
        this.loadingCreateMsg = false
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promblem issue connect api : /line-bot/ai/app/`,
        });
      }

    },

    async sendMessage() {

      this.viewHistoryChat = false
      let textFiled = `${this.newMessage}`
      let arrHead = []
      let arrMessage = []
      let message = {
        message: `${this.newMessage}`,
        username: this.$store.state.role.RulesUser.roles.includes('staff') || this.$store.state.role.RulesUser.roles.includes('faculty') ? `u${this.userName}` : `${this.$store.state.role.RulesUser.username}`
      }
      console.log(this.activeChat)
      this.activeChat.messages.push(
        { id: '77777', from: "me", text: this.newMessage, time: this.moment().format('LT') },
        { id: 'loading send', from: "them", text: `Copter is thinking... 🤔`, time: this.moment().add(5, 'minutes').format('LT') }
      );
      this.newMessage = "";

      try {
        const res = await this.$http.post(`/line-bot/ai/app/${this.activeChat.id}/send_message/`,
          JSON.stringify(message),
          {
            headers: { "Content-Type": "multipart/form-data, application/json" },
          }
        )
        if ([200, 201].includes(res.status)) {
          // เอา loading ออก
          const indexLoading = this.activeChat.messages.findIndex(itemLoad => itemLoad.id === 'loading send')
          this.activeChat.messages.splice(indexLoading, 1);
          /////
          if (this.firstChat != '') {
            /// เอา textFiled update title
            const indexUpArrHead = this.chats.findIndex(item_indexUpArrHead => item_indexUpArrHead.id === this.activeChat.id)
            this.chats[indexUpArrHead] = {
              ...this.chats[indexUpArrHead],
              name: `${textFiled}`
            }
          }
          ///// ----
          const indexUpArrMessage = this.chats.findIndex(item_indexUpArrMessage => item_indexUpArrMessage.id === this.activeChat.id)
          // เอา res ไปเติมใน arrMessage
          this.chats[indexUpArrMessage].messages.push({
            id: res.data.assistant_message.id,
            from: "them",
            text: `${res.data.assistant_message.content}`,
            time: this.moment(res.data.assistant_message.created_at).format('LT')
          })

          this.viewHistoryChat = true
        }
        else {
          const error = new Error('API Error');
          error.res = res;
          throw error;
        }
      } catch (error) {
        console.log(error.response)
        if (this.firstChat != '') {
          /// เอา textFiled update title
          const indexUpArrHead = this.chats.findIndex(item_indexUpArrHead => item_indexUpArrHead.id === this.activeChat.id)
          this.chats[indexUpArrHead] = {
            ...this.chats[indexUpArrHead],
            name: `${textFiled}`
          }
        }
        // เอา loading ออก
        const indexLoading = this.activeChat.messages.findIndex(itemLoad => itemLoad.id === 'loading send')
        this.activeChat.messages.splice(indexLoading, 1);
        ///
        const indexUpArrMessage = this.chats.findIndex(item_indexUpArrMessage => item_indexUpArrMessage.id === this.activeChat.id)
        this.chats[indexUpArrMessage].messages.push({
          id: `${error.response.status}`,
          from: "them",
          text: `<span class='text-danger'>[Code ${error.response.status} !!] Copter Error : ${error.response.statusText} </br> Please refresh page and create new toppic</span>`,
          time: this.moment().format('LT')
        })
        this.viewHistoryChat = true
        //   style: {
        //     backgroundColor: "#ff1919",
        //     color: "#ffffff",
        this.firstChat = ''
      }

      // --------

    },

  },
  mounted() {

    globalThis.addEventListener("resize", this.checkScreenSize);

    this.checkScreenSize();
    this.scrollToBottom(); // ให้ scrollbar อยู่ด้านล่างสุดเมื่อโหลด

    if (this.$store.state.role.RulesUser.roles.includes("student")) {
      this.getStudentProfile();
    } else {
      this.loadProfile = true;
      this.getBaseProfile();
    }

    this.getHistory();

  },
  updated() {
    this.scrollToBottom(); // เลื่อนลงล่างทุกครั้งที่มีข้อความใหม่
  },
  created() {
  },
  beforeDestroy() {
    globalThis.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>

<style scoped>
/* รีเซ็ต */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Sarabun', sans-serif;
}

/* Layout หลัก */
.chat-container {
  display: flex;
  height: 97dvh !important;
  width: 100%;
  border-radius: 0;
}

/* Card Profile */
.profile-main {
  display: flex;
  flex-direction: column;
}

.profile-card {
  display: flex;
  align-items: center;
  background: white;
  padding: 9px;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
}

.profile-avatar {
  width: 60px;
  height: 60px;
  border-radius: 20px 20px 0 0;
  /* border-radius: 50%; */
  margin-right: 15px;
}

.profile-info h3 {
  margin: 0;
  font-size: 18px;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.status {
  font-size: 14px;
  color: gray;
}

.online {
  color: green;
}

.offline {
  color: red;
}

/* Sidebar (รายการแชท) */
.sidebar {
  width: 300px;
  background: #fff;
  border-right: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  box-shadow: 3px 0 10px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f0f0f0;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  font-family: 'Sarabun', sans-serif !important;
  font-weight: 900;
}

.sidebar-hidden {
  display: none;
}

/* รายการแชท */
.chat-name {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: 900;
  font-size: 16px;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.chat-list {
  list-style: none;
  overflow-y: auto;
  flex: 1;
  padding: 10px;
}

.chat-list li {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  /* เพิ่มระยะห่างภายในให้มากขึ้น */
  margin: 8px 0;
  /* เพิ่มระยะห่างระหว่างรายการ */
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.3s, transform 0.3s ease, margin 0.3s;
}

/* เมื่อ Hover บน chat-list */
.chat-list li:hover {
  background: #e0e0e0;
  /* สีพื้นหลังเมื่อ Hover */
  transform: scale(1.03);
  /* ขยายเล็กน้อย */
  margin-left: 10px;
  /* ย้ายรายการไปทางซ้ายเล็กน้อย */
  margin-right: 10px;
  /* ย้ายรายการไปทางขวาเล็กน้อย */
}

/* เมื่อรายการ Chat เป็น Active */
.active-chat {
  background: #E6E6FA;
  /* สีม่วงอ่อนสำหรับ active */
  color: #4A235A;
  font-weight: bold;
  transform: scale(1.05);
  margin-left: 10px;
  /* ย้ายรายการไปทางซ้ายเล็กน้อย */
  margin-right: 10px;
  /* ย้ายรายการไปทางขวาเล็กน้อย */
}

/* กล่องแชท */

.chat-messages {
  height: calc(100dvh - 120px);
  overflow-y: auto;
  transition: height 0.3s ease;
}

.shrink-messages {
  height: 50dvh;
}

.chat-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0px;
  box-shadow: -3px 0 10px rgba(0, 0, 0, 0.1);
}

/* Header แชท */
.chat-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #462279;
  color: white;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
}

.chat-header h6 {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: 500;
  margin-left: 10px;
}

/* กล่องข้อความ */
.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  background: #d6d6d6;
  display: flex;
  flex-direction: column;
  border-radius: 0;
}

/* ข้อความ */
.message {
  max-width: 90%;
  padding: 12px;
  border-radius: 18px;
  margin: 5px 0;
  position: relative;
  font-size: 20px;
  word-wrap: break-word;
}

.sent {
  align-self: flex-end;
  background: #dcf8c6;
  text-align: right;
  padding: 12px;
}

.received {
  align-self: flex-start;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 18px 18px 18px 0px;
}

/* ข้อความ */
.message-text {
  margin: 0;
}

/* เวลา (timestamp) */
.message-time {
  font-size: 12px;
  color: gray;
  display: block;
  margin-top: 5px;
}

/* ช่องพิมพ์ข้อความ */
.chat-input {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #ddd;
}

.chat-input input {
  flex-grow: 1;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
}

/* ปุ่ม Send (แบบ Round UI + สีม่วงอ่อน) */
.chat-input button {
  background-color: #4A235A;
  margin-left: 10px;
  padding: 10px 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.3s ease;
  color: #ffffff;
  font-weight: 700;
}


.btn-create button {
  background-color: #4A235A;
  margin-left: 10px;
  padding: 10px 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.3s ease;
  color: #ffffff;
  font-weight: 700;
}


.chat-input button:hover {
  background: #D8BFD8;
  /* สีม่วง Pastel เวลาชี้เมาส์ */
  transform: scale(1.1);
  /* ทำให้ขยายเล็กน้อย */
}

/* Responsive */
@media (max-width: 767px) {

  .chat-container {
    height: 100dvh;
    border-radius: 0%;
  }

  .sidebar {
    width: 100%;
    height: 100vh;
    border-radius: 0;
    border: 0px solid #ccc;
    overflow-y: auto;
  }

  .chat-list {
    max-height: 70dvh;
    overflow-y: auto;
  }

  .chat-messages {
    height: calc(100dvh - 120px);
    overflow-y: auto;
    transition: height 0.3s ease;
  }

  .chat-box {
    width: 100%;
    height: 95dvh;
  }

  .chat-header {
    display: flex;
    align-items: center;
    padding: 15px;
    background: #462279;
    color: white;
    border-bottom: 1px solid #ccc;
    border-radius: 0;
  }

  .chat-name {
    font-family: 'Sarabun', sans-serif !important;
    font-weight: 900;
    font-size: 18px;
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

}

/* Scrollbar ทั่วไป */
::-webkit-scrollbar {
  width: 6px;
  /* ทำให้แคบลง */
}

/* สีพื้นหลังของ Scrollbar */
::-webkit-scrollbar-track {
  background: #f0f0f0;
  /* สีเทาอ่อน */
  border-radius: 10px;
}

/* แถบ Scrollbar */
::-webkit-scrollbar-thumb {
  background: #d6d6d6;
  /* สีม่วงอ่อน */
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
}

/* เมื่อ Hover บน Scrollbar */
::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6;
  /* สีม่วงเข้มขึ้นเล็กน้อย */
}


/* 🎨 ปรับแต่ง Markdown ให้สวยงาม */
.markdown-content {
  font-family: 'Sarabun', sans-serif;
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  max-width: 600px;
  word-wrap: break-word;
}

/* 🎯 หัวข้อ */
.markdown-content h1 {
  font-family: 'Sarabun', sans-serif;
  font-size: 18px;
  border-bottom: 2px solid #d8bffd;
  padding-bottom: 5px;
  margin-bottom: 10px;
}

.markdown-content h2 {
  font-size: 1.3em;
  border-bottom: 1px solid #d8bffd;
  padding-bottom: 4px;
  margin-bottom: 8px;
}

/* 🎯 ลิสต์ */
.markdown-content ul,
.markdown-content ol {
  padding-left: 20px;
}

/* 🎯 Code Block */
.markdown-content pre {
  background: #2d2d2d;
  color: #f8f8f2;
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;
  font-family: 'Sarabun', sans-serif;
  font-size: 18px;
}

.markdown-content code {
  background: #f4f4f4;
  padding: 2px 5px;
  border-radius: 3px;
}

/* 🎯 Blockquote */
.markdown-content blockquote {
  border-left: 4px solid #d8bffd;
  padding-left: 10px;
  margin-left: 0;
  color: #555;
  font-style: italic;
}

/* ปิดการใช้งาน (disabled) */
input:disabled,
button:disabled {
  background-color: #ddd;
  cursor: not-allowed;
}
</style>
